import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { hasScopesResolver } from '@mds/ngx-auth';
import { assignableShiftsResolver } from '../../shared/resolvers/assignable-shifts.resolver';

export const vehiclePlanningRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.VehiclePlanning.List.Title'),
    resolve: {
      assignableShifts: assignableShiftsResolver,
      hasShiftWriteScope: hasScopesResolver(['shifts:write']),
      hasWriteScope: hasScopesResolver(['deployments:write']),
      hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
    },
    loadComponent: () =>
      import('./vehicle-planning-list/vehicle-planning-list.component').then(
        (m) => m.VehiclePlanningListComponent,
      ),
  },
];
